/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e="prevArrow.title",r="nextArrow.title",t={[e]:"Previous tab arrow",[r]:"Next tab arrow"};exports.messages=t;exports.nextArrowTitle=r;exports.prevArrowTitle=e;
